import { cloneDeep } from 'lodash'
import { ColDef } from 'components//visualization/Table/types'
import COL_DEFS from './colDefs'

/**
 * convert measures to corresponding column definitions
 * @param displayedMeasures measures to be displayed in table
 */
const convertToColDefs = (displayedMeasures: (string | undefined)[]) => {
  const allColDefs = cloneDeep(COL_DEFS)
  const isDisplayColumn = (colDef: ColDef<any, any, any>) =>
    displayedMeasures.includes(colDef.field as string)
  const topicNameColumn = allColDefs[0]

  return [
    // first column is fixed
    topicNameColumn,
    ...allColDefs.filter(isDisplayColumn)
  ]
}

export default convertToColDefs
